import FeesCard from "./FeesCard";

export default function Class4() {
  return (
    <FeesCard
        badge="Class 4"
        title="💰 Class 4 Tuition Details"
        className="4th Standard"
        fee="₹1,000"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "English",
          "Mathematics",
          "Science",
          "Social Studies"
        ]}
        approach={[
          "Structured learning",
          "Doubt clearing",
          "Revision tests"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
  );
}